import axios from "./axios";

class PGService {
  getUPIQR = async (amount) => {
    try {
      const response = await axios.post("/pg/payu/get_qr", { amount });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  hdfcBankCreateOrder = async (amount) => {
    try {
      const response = await axios.post("/pg/hdfcbank/create_order", {
        amount,
        channel: "WEB",
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  hdfcBankInitiateRechargePayment = async (number, operator, amount) => {
    try {
      const response = await axios.post(
        "/pg/hdfcbank/initiate_recharge_payment",
        {
          operator,
          number,
          amount,
          channel: "WEB",
        },
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  txnStatus = async (order_id) => {
    try {
      const response = await axios.post("/pg/txn_status", { order_id });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  recentTransactions = async () => {
    try {
      const response = await axios.post("/pg/recent_transactions", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new PGService();
